import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { listSetDescription } from '../../../../../../../../rest/effects/list/listSetDescription';

export const saveListDescription = (
    listId: number,
    description: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(listSetDescription(listId, description))
    };
    return action;
};
